import React, { useState } from 'react'
import '../../index.css'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import VehicleSelect from '../UI/VehicleSelect'
import { styled } from '@mui/material/styles'
import { useSelector } from 'react-redux'

const PREFIX = 'Attack-dialog'
const classes = {
  main: `${PREFIX}`,
}

const DialogStyled = styled(Dialog)({
  [`&.${classes.main} .MuiDialogContent-root`]: {
    padding: '8px 24px',
  },
  [`&.${classes.main} .MuiTypography-h6`]: {
    textAlign: 'center',
  },
  [`&.${classes.main} .MuiOutlinedInput-input`]: {
    padding: '10.5px 14px',
  },
  [`&.${classes.main} .MuiFormLabel-root`]: {
    color: 'color: gray !important;',
    fontSize: 14,
  },
})

export default function AttackDialog(props) {
  const { projects, selectedProjectId } = useSelector(state => state)
  const [name, setName] = useState('')
  const [speed, setSpeed] = useState('')
  const [length, setLength] = useState('')
  const [vehicle, setVehicle] = useState('')

  const units = projects.filter(p => p.id === selectedProjectId)[0].units

  const handleClose = () => {
    props.onChange(false)
    setName('')
    setSpeed('')
    setLength('')
    setVehicle('')
  }

  const handleOk = () => {
    props.onChange(false, name, speed, length, vehicle)
    setName('')
    setSpeed('')
    setLength('')
    setVehicle('')
  }

  const handleSpeedChange = e => {
    setSpeed(e.target.value)
  }

  const handleNameChange = e => {
    setName(e.target.value)
  }

  const handleLengthChange = e => {
    setLength(e.target.value)
  }

  const handleVehicleChange = (e, values) => {
    setVehicle(values.vehicle)
  }

  return (
    <DialogStyled
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-attack"
      className={classes.main}
    >
      <DialogTitle id="form-dialog-title">Add Attack</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          className="text-field-font"
          margin="dense"
          id="name"
          label="Name"
          variant="outlined"
          value={name}
          fullWidth
          onChange={handleNameChange}
        />
        <TextField
          margin="dense"
          id="speed"
          label={`Starting Speed [${units.speedUnits}]`}
          variant="outlined"
          value={speed}
          fullWidth
          onChange={handleSpeedChange}
        />
        <TextField
          margin="dense"
          id="length"
          label={`Path Length [${units.distanceUnits}]`}
          variant="outlined"
          value={length}
          fullWidth
          onChange={handleLengthChange}
        />
        <VehicleSelect onChange={handleVehicleChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} color="primary">
          Add
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </DialogStyled>
  )
}
